import React from 'react'
import { ActionableTable } from '../Table/ActionableTable'
import { useTranslation } from 'react-i18next'

export interface UnassignTutorsTableProps {
  rows: {
    roleName: string
    fullName: string
    validFrom?: string
    validTo?: string
  }[]
}

export const UnassignedTutorsTable: React.FC<UnassignTutorsTableProps> = ({
  rows,
}) => {
  const { t } = useTranslation()
  return (
    <ActionableTable
      rowHeight={35}
      columns={[
        {
          fieldName: 'roleName',
          columnHeaderName: t(
            'Dashboard.UnassignedTutorsTable.Column.RoleName',
            'Role Name'
          ),
        },
        {
          fieldName: 'fullName',
          columnHeaderName: t(
            'Dashboard.UnassignedTutorsTable.Column.FullName',
            'Full Name'
          ),
        },
        {
          fieldName: 'validFrom',
          columnHeaderName: t(
            'Dashboard.UnassignedTutorsTable.Column.StartDate',
            'Start Date'
          ),
        },
        {
          fieldName: 'validTo',
          columnHeaderName: t(
            'Dashboard.UnassignedTutorsTable.Column.EndDate',
            'End Date'
          ),
        },
      ]}
      noResultsMessage={t(
        'Dashboard.UnassignedTutorsTable.Column.FullName',
        'No Results Found'
      )}
      rows={rows}
    />
  )
}
